import { render, staticRenderFns } from "./BusinessNameRegistrationEscalations.vue?vue&type=template&id=216ad246&scoped=true&"
import script from "./BusinessNameRegistrationEscalations.vue?vue&type=script&lang=js&"
export * from "./BusinessNameRegistrationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameRegistrationEscalations.vue?vue&type=style&index=0&id=216ad246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ad246",
  null
  
)

export default component.exports